/**
 * vue-actionbox
 * @version 2.0
 * @author Čeněk Hybler <cenek.hybler@avast.com>, Jaroslav Slaby <jaroslav.slaby@avast.com>,
 * @requires avast.web.campaignMarkerCookie
 * @requires avast.web.downloadPopup
 */

 (function() {
	'use strict';
	Vue.config.devtools = true;

	Vue.config.errorHandler = function(err, vm, info) {
		console.log('errorHandler');
		console.log(1, err);  // err: error trace
		console.log(2, vm);   // vm: component in which error occured
		console.log(3, info); // info: Vue specific error information such as lifecycle hooks, events etc.
		// TODO: Perform any custom logic or log to server
	};

	var detectedPlatform = avastGlobals.detect.browser.platform.toLowerCase(),
		aboxWrapElement = document.querySelectorAll('.js-abox-wrap'), // lookup for all abox components on page
		campaignMarkerModule = avm.require('avast.web.campaignMarkerCookie')(),
		downloadPopup = avm.require('avast.web.downloadPopup');

	// Terminate if no aboxes present on the page
	// Todo : this can be defined in avast.js config where modules boot
	if (aboxWrapElement.length === 0) {
		return false;
	}

	// Components
	// ---------------------------------------------------------------------------------------
	// DATA - uvodní reaktivní data instance dané komponenty
	// PROPS - Vlastnosti komponenty (chápu jako data předávané z rodiče)
	// METHODS - Volají se při kompilaci. Funkce dostupné jak v templatě tak v komponentě
	// COMPUTED - Computed property. Neakceptuje parametry, není to funkce. Reaguje na změny

	// main abox-container
	Vue.component('Container', {
		template: '#container',
		delimiters: ['<%', '%>'],
		props: ['settings', 'setup', 'table', 'theme'],
		data: function() {
			return {
				setup: this.setup,
				showToggler: this.setup.togglersCount > 0 ? true : false,
				themeClass: 'theme-' + this.theme,
				tableClass: this.table === 'true' ? 'table-view' : false,

			};
		},
		computed: {
			promoClass: function() {
				return this.setup.promotedBox ? 'promo-'+ this.setup.promotedBox : false;
			},
			promoMulti: function() {
				// returns promo frame position (multibox, table or false)
				var position = false;
				if (this.setup.promotedBox) {
					var
						address = this.setup.renderedBoxes[this.setup.promotedBox-1],
						isMulti = this.setup.sets[address.set].options[address.option].optionType === 'multi' ? true : false;

					if (isMulti && this.setup.sets[address.set].options[address.option].promotedBox == 1) {
						position = 'multi-start';
					} else if (isMulti && this.setup.sets[address.set].options[address.option].promotedBox == this.setup.sets[address.set].options[address.option].boxesCount) {
						position = 'multi-end';
					} else if (isMulti) {
						position = 'multi';
					} else if (this.table === "true") {
						position = 'in-table';
					}
				}
				return position;
			},
			multiboxClass: function() {
				var
					hasMultibox = false, // info whether there is multibox among rendered boxes
					renderedBoxes = this.setup.renderedBoxes; //addresses of all displayed boxes

				// for each rendered box take address and find by it in setup if it's type is multibox
				for (var b = 0; b < Object.keys(renderedBoxes).length; b++) {
					var address = renderedBoxes[b];

					if (!hasMultibox) {
						hasMultibox = this.setup.sets[address.set].options[address.option].optionType === 'multi' ? true : false;
					}
				}
				return hasMultibox == true ? 'has-multibox' : false;
			},
		},
		methods: {
			changeIndex: function(event, indexValue, setIndex) {
				this.$emit('change_data', event, indexValue, setIndex);
			},
			getOptionData: function(address) {
				var
					optionIndex = address.option, // index of the box
					setIndex = address.set,
					setOptions = this.settings[setIndex].options,
					optionData;

				// go through options in this set, find the selsected one by index and check out the pricelist
				Object.keys(setOptions).forEach(function(optionName, i) {
					if (i == optionIndex) {
						optionData = setOptions[optionName];
					}
				});
				return optionData;
			}
		}
	});


	// Toggler
	Vue.component('Toggler', {
		template: '#abox-toggler',
		delimiters: ['<%', '%>'],
		props: [
			'setup',
			'settingIndex', // index of given setting
			'selectedIndex', // selected value index
			'firstBox',
			'lastBox',
		],
		data: function() {
			return {
				hasToggler: this.setup.sets[this.settingIndex].hasToggler, // determine whether to render the toggler
				togglerValues: this.setup.sets[this.settingIndex].togglerValues, // Text values for all toggler's option in array
				horizontalToggler: this.setup.sets[this.settingIndex].horizontalToggler, // Type of toggler
			};
		},
		methods: {
			togglerClick: function(event, indexValue, setIndex) {
				this.$emit('change_data', event, indexValue, setIndex);
			}
		}
	});


	// Abox
	Vue.component('Abox', {
		template: '#abox',
		delimiters: ['<%', '%>'],
		props: [
			'boxOrder',        // index of the box
			'boxAddress',      // address is the object in setup with instructions where to search for data for this box in the settings
			'optionData',      // setting for the option
			'saveText',        // default label text when discounted price is in place
			'legalText',       // 1 year legal sentence
			'legalText2Years', // 2 years legal sentence
			'legalText3Years', // 2 years legal sentence
			'legalTextMonth',  // monthly legal sentence (GB)
			'firstYearText',   // 'Price for the first year' text
			'first2YearsText', // 'Price for the first 2 years' text
			'first3YearsText', // 'Price for the first 3 years' text
			'firstMonthText',  // 'Price for the first month' text
			'billedNowText',   // '<s>%fullPrice%</s> %discountedPrice% billed now for the first year' text
			'currentText',     // 'Current price' text
			'originalText',    // 'Original price' text
			'subscriptionText',// US subscription text
			'buttonDefaultText'// Default button text
		],
		data: function() {
			return {
				pricelist: this.getPricelist(),      // make price data easily accessible
				multidata: this.getMultiData(),      // have multidata generated only once per render
				spanned: !this.getPricelist() && !this.getVal('price_title') && this.getVal('instructions') != null, // info whether slot should span across more rows
				legalNoteEnd: '</span>&nbsp;<span class="sub-icon"></span></span>',
			};
		},
		updated: function() {
			// Refresh data for this box after index change
			this.pricelist = this.getPricelist();
			this.multidata = this.getMultiData();
			this.spanned = !this.getPricelist() && !this.getVal('price_title') && this.getVal('instructions') != null;
			this.setCampaignMarker();

			// lookup all download buttons in this instance and link it with DTYPopup
			var button = this.$el.querySelector('a[data-role="download-link"]:not([data-behavior="downloadPage"])');
			if(button !== null) {
				downloadPopup.setPopup(button);
				console.log("dtyp", button);
			}
		},
		mounted: function() {
			// once the DOM is rendered, update the content
			this.setCampaignMarker();

			// lookup all download buttons in this instance and link it with DTYPopup
			var button = this.$el.querySelector('a[data-role="download-link"]:not([data-behavior="downloadPage"])');
			if(button !== null) {
				downloadPopup.setPopup(button);
			}

			// create modal for legal text
			var modalButton = this.$el.querySelector('[data-toggle="modal"]');
			initModal(modalButton);
		},
		watch: {
			CTANoteText: {
				// Everytime when CTANoteText changed:
				handler: function(val) {
					this.$nextTick(function() {
						//console.log("watch tick");
						// create modal for legal text
						var modalButton = this.$el.querySelector('[data-toggle="modal"]');
						initModal(modalButton);
					});
				}
			}
		},
		computed: {
			getPlatfromIcons: function() {
				var icons = false;
				if (this.optionData.platforms != null) {
					this.optionData.platforms.forEach(function(icon, i, arr) {
						arr[i] = icon === 'pc' ? 'win' : icon; // make sure that only valid name of platform is returned
					});
					icons = this.optionData.platforms;
				}
				return icons;
			},
			getLabelText: function() {
				var
					label = this.getVal('labels').text,
					value = label && label !== '' ? label : false;

				// if there is not custom text defined, check if there is a discount in pricelist
				if (!value) {
					if (this.pricelist && this.pricelist.discountPercentFormatted && this.pricelist.discountPercentFormatted !== '') {
						value = this.saveText.replace('$$', this.pricelist.discountPercentFormatted).replace('&nbsp;', ' ');
					}
				}
				return value;
			},
			getLabelVariant: function() {
				var
					value = this.getVal('labels').variant,
					labelVar = value && value !== '' ? value : 'green-bright'; // default variant is green-bright
				return labelVar;
			},
			buttonVariant: function() {
				// checks if there is defined custom button variant. Default is primary.
				// It is possible to send values like 'secondary', 'secondary monochrome' or 'primary disabled' to achieve various results
				var
					value = this.getVal('button_variant'),
					btnVar = value && value != '' ? 'btn-' + value : 'btn-primary';

				return btnVar;
			},
			buttonSize: function() {
				// checks if there is defined custom button size. Default is small.
				var
					value = this.getVal('button_size'),
					btnSize = value && value != '' ? 'btn-' + value : 'btn-sm';

				return btnSize;
			},
			buttonText: function() {
				// checks if there is defined custom button text. Default is 'Buy Now'.
				var
					value = this.getVal('button_text'),
					btnText = value && value != '' ? value : this.buttonDefaultText;

				return btnText;
			},
			showListPrice: function() {
				// in default, always show list price unless set to 'false' in parameter
				// EN-GB has hidden list price
				if (avastGlobals.web.locale === 'en-gb') {
					return false;
				} else {
					var result = this.getVal('show_listPrice', false) === 'false' ? false : true;
					return result;
				}
			},
			showCTANote: function() {
				var note = this.getVal('cta_note');

				// show note when there is custom note...
				if (note) {
					return true;
				// ...or GB with pricelist (US and GB have always legal notes) or discount
				} else if (this.pricelist && (avastGlobals.web.locale === 'en-gb' || (this.pricelist.discountPercent && this.pricelist.discountPercent !== ''))) {
					return true;
				// no custom note, undiscounted outside US or GB and trial boxes
				} else {
					return false;
				}
			},
			CTANoteText: function() {
				var
					noteContent = this.getVal('cta_note'), // return the cta note content or false if not found
					auto_cta_note = this.optionData['auto_cta_note'] === 'false' ? false : true; // default value is true if not set as false

				// If there is a pricelist lets do some circus with the content:
				if (this.pricelist && auto_cta_note) {
					var
						discount = this.pricelist.discountPercent && this.pricelist.discountPercent !== '' ? this.pricelist.discountPercent : false, // set the discount value or false if not found
						maintenance = this.pricelist.maintenance ? this.pricelist.maintenance : false,
						legalNote = this.getLegalNote(maintenance),
						billingContent = '',
						subscriptionContent = '';

					// if there is a discount, add a generic text to the custom note
					if (discount) {
						if (maintenance == 1) { // price is for one month
							billingContent = this.firstMonthText;

						} else if (isYearPeriod(this.pricelist)) { // price is yearly
							billingContent = maintenance === '36' ? this.first3YearsText : (maintenance === '24' ? this.first2YearsText : this.firstYearText);

						} else { // if price yearly per month, look up for and set yearly prices
							var
								// values calculated in the cmp-abox snippet:
								yearPriceDiscounted = this.getVal('yearPriceDiscounted' + maintenance),
								yearPriceFull = this.getVal('yearPriceFull' + maintenance);

							billingContent = yearPriceDiscounted && yearPriceFull ? legalNote.replace('$$', yearPriceFull).replace('ŁŁ', yearPriceDiscounted) : legalNote;
						}
					}

					// Add GB legal content to whatever note content
					if (avastGlobals.web.locale === 'en-gb'){
						if (isYearPeriod(this.pricelist)) {
							// price is yearly so show price for one price
							subscriptionContent = this.legalSuffixStart() + legalNote.replace('$$', this.getVal('yearPriceFull')) + this.legalNoteEnd;
						} else {
							var fullPrice = this.pricelist.priceRounded && this.pricelist.currencySymbol ? this.pricelist.priceFormat.replace('#c', this.pricelist.currencySymbol).replace('#p', this.pricelist.priceRounded) : false;

							// price is monthly so show price for one month
							subscriptionContent = this.legalSuffixStart() + legalNote.replace('$$', fullPrice) + this.legalNoteEnd;
						}

					} else {
						// Add legal content to whatever note content (formerly only for US, then expanded to ROW in GLOWEB-7661)
						var legalSuffix = this.legalSuffixStart() + this.subscriptionText + this.legalNoteEnd;

						if (billingContent.length > 0) {
							var specialDotLocales = ['ja-jp', 'zh-cn', 'zh-tw'];

							if (specialDotLocales.indexOf(avastGlobals.web.locale) > -1) {
								var fixedDot = (billingContent.slice(-1) !== '。') ? '。 ' : ' ';
							} else {
								var fixedDot = (billingContent.slice(-1) !== '.') ? '. ' : ' ';
							}

							subscriptionContent = billingContent + fixedDot + legalSuffix; // adds period (if its missing) and legal text
						} else {
							subscriptionContent = legalSuffix;
						}
					}

					// Join all legal texts together
					if (subscriptionContent.length > 0) {
						noteContent = noteContent ? (noteContent + '<br>' + subscriptionContent) : subscriptionContent;
					} else {
						noteContent = noteContent ? (noteContent + '<br>' + billingContent) : billingContent;
					}
				}


				// set A11y screen reader text to cta_note with strike through original price
				if (/<s>.+<\/s>/.test(noteContent)) {
					noteContent = noteContent.replace(/<s>/, '<span class="sr-only">' + this.originalText + '</span><s>').replace(/<\/s>/, '</s> <span class="sr-only">'+ this.currentText + '</span>')
				}

				return noteContent;
			},
		},
		methods: {
			getVal: function(paramName, convertToBoolean) {
				var
					boolCheck = convertToBoolean != null ? convertToBoolean : true, // default is true - always convert string boolean to boolean
					paramArr = this.optionData[paramName] ? this.optionData[paramName] : false, // retrieve value of given parameter
					isString = false,
					boxPriceIndex = 0,
					value = false,
					paramValue;

				// Check type of parameter
				if (paramArr && paramArr !== '') {
					isString = typeof(paramArr) === 'string' ? true : false, // check if value is just a string
					boxPriceIndex = paramArr instanceof Array ? this.boxAddress.price : this.boxAddress.price + 1;// control of param type (array or object). (pressume there will be no other types entered (please))
				}

				// if box is not part of multibox and only string then return as it is (used for singleboxes or same value for all boxes(e.g. period_text))
				if (isString) {
					value = paramArr;

					// if NOT a string, takes only the first item in object/array or from proper index
				} else {
					value = paramArr[boxPriceIndex] && paramArr[boxPriceIndex] !== '' ? paramArr[boxPriceIndex] : false;
				}

				if (boolCheck) {
					// check whether there is true/false value as string and convert it to boolean
					paramValue = !value || value === 'false' ? false : (value === 'true' ? true : value);
				} else {
					paramValue = value;
				}

				return paramValue;
			},

			getLegalNote: function(maintenance) {
				// select proper sentence for legal note
				if (avastGlobals.web.locale === 'en-gb' && !isYearPeriod(this.pricelist)) {
					return this.legalTextMonth;
				} else if (maintenance){
					return maintenance === '36' ? this.legalText3Years : (maintenance === '24' ? this.legalText2Years : this.legalText);
				} else {
					return this.legalText;
				}
			},
			legalSuffixStart: function() {
				var
					modalTargetSuffix = avastGlobals.web.locale === 'en-gb' ? (isYearPeriod(this.pricelist) ? '-gb' : '-gb-month') : '',
					legalNoteStart = '<span class="subscription-link" data-toggle="modal" data-target="subscription-modal' + modalTargetSuffix + '" tabindex="0" role="button"><span class="sub-text">';
				return legalNoteStart;
			},
			setCampaignMarker: function() {
				var cartLinks = this.$el.querySelectorAll('[data-role="cart-link"]');

				// Update campaign marker data and href attributes with __trSrc cookie
				if (cartLinks.length) {
					campaignMarkerModule.setCampaignMarkerCookie(cartLinks);
				}
				// TODO - Description of this code:
				if(avastGlobals.web.abtest !== undefined) {
					cartLinks.forEach(function(el) {
						var dataCM = el.getAttribute('data-campaign-marker').split('~'),
							hrefCM = el.getAttribute('href').split('~'),
							abTest = avastGlobals.web.abtest.ticketNumber,
							testVariant = avastGlobals.web.abtest.testVariant;

						dataCM[3] = abTest;
						dataCM[4] = testVariant;
						hrefCM[3] = abTest;
						hrefCM[4] = testVariant;
						el.setAttribute('data-campaign-marker', dataCM.join('~'))
						el.setAttribute('href', hrefCM.join('~'))
					})
				};
				return cartLinks;
			},
			getPricelists: function() {
				// Return array of pricelists for this option
				var optionPricelists = false;

				if (this.optionData.pricelist != null) {
					optionPricelists = this.optionData.pricelist;
				}
				return optionPricelists;
			},
			getPricelist: function() {
				// Return pricelist for this box defined by price index in address
				var
					pricelists = this.getPricelists(),
					priceIndex = this.boxAddress.price,
					pricesCount = Object.keys(pricelists).length,
					optionPricelist = false;

				if (pricesCount > 0) {
					Object.keys(pricelists).forEach(function(productId, j) {
						if (j == priceIndex) {
							optionPricelist = pricelists[productId];
						}
					});
				}
				return optionPricelist;
			},
			getMultiData: function() {
				var
					pricelists = this.getPricelists(),
					listCount = pricelists ? Object.keys(pricelists).length : 0,
					multibox = false;

				// detection if this box is part of multibox and what is it's order in the scope of this multibox
				if (listCount > 1) {
					if (this.boxAddress.price == 0) {
						multibox = 'start';
					} else if (this.boxAddress.price == listCount - 1) {
						multibox = 'end';
					} else {
						multibox = true;
					}
				}
				return multibox;
			}
		}
	});

	// Price
	Vue.component('Price', {
		template: '#abox-price',
		delimiters: ['<%', '%>'],
		props: [
			'pricelist',
			'period',
			'periodTextYear',
			'periodText2Years',
			'periodText3Years',
			'periodTextMonthly',
			'showListPrice'
		],
		computed: {
			// position of currency symbol
			symbolShowPrefix: function() {
				return /^#c/.test(this.pricelist.priceFormat);
			},
			symbol: function() {
				if (this.symbolShowPrefix) {
					return this.pricelist.currencySymbol.replace('&nbsp;', '');
				} else {
					return '&nbsp;' + this.pricelist.currencySymbol.replace('&nbsp;', '');
				}
			},
			decimal: function() {
				return this.pricelist.decimalSeparator + this.pricelist.realPriceDecimalPart;
			},
			showDecimal: function() {
				return this.pricelist.realPriceDecimalPart !== '';
			},
			getPeriod: function() {
				if (this.period) {
					// custom text for period (e.g. /call)
					return this.period;
				} else if (isYearPeriod(this.pricelist)) {
					// price is yearly
					return this.pricelist.maintenance === '36' ? this.periodText3Years : (this.pricelist.maintenance === '24' ? this.periodText2Years : this.periodTextYear);
				} else {
					// price is monthly
					return this.periodTextMonthly;
				}
			},
			getNewPrice: function() {
				return this.pricelist.priceFormat.replace('#c', this.pricelist.currencySymbol).replace('#p', this.pricelist.realPriceIntegerPart);
			},
		},
		methods: {
			stripHtml: function(text) {
				var e = document.createElement('div');
				e.innerHTML = text.replace('3× de',''); //remove installments <span class="installments">3× de</span>

				return e.childNodes.length === 0 ? '' : e.childNodes[0].innerText;
			}
		}
	});



	// Init (One VUE object for each abox element on page)
	// --------------------------------------------------------------------------------------------------------------
	for (var i = 0; i < aboxWrapElement.length; i++) {
		var element = aboxWrapElement[i],
			settings = JSON.parse(element.getAttribute('data-settings'));

		// avoid JS error if settings is null
		if (!settings && settings === null) {
			settings = [];
		}


		// MAIN PARENT OBJECT
		// --------------------------------------------------------------------------------------------------------------
		element = new Vue({
			el: element,
			delimiters: ['<%', '%>'],
			data: function() {
				return {
					settings: settings,
					setup: {
						"settingsCount": settings.length, // počet všech settings (#)
						"togglersCount": 0,        // togglers count to add class to container
						"renderedBoxesCount": 0,   // how many aboxes should be rendered based on default indexes of all settings
						"renderedBoxes": [],       // addresses of rendered boxes
						"sets": [],
						"promotedBox": false,      // to set proper class for promoted box
					}
				};
			},
			created: function () {
				// Values for the Setup
				// --------------------------------------------------------------------------------------------------------------
				// - settings - all settings of whole CONTAINER
				// - setting - single setting (rendered as separate ABOX/MULTIBOX)
				// - option - values of an option in the given box (setting) (switched with toggler)
				for (var s = 0; s < this.settings.length; s++) {
					var
						setting = this.settings[s], // each setting from settings
						defaultIndex = 0, // default index per setting is 0
						hasToggler = false, // is there a toggler for this setting?
						horizontalToggler, // type of toggler
						settingOptionsNames = Object.keys(setting.options); // array of this setting options names

					// Togglers count ---------------------------
					// if the given setting has more options, there will be toggler
					// also if there is only one option but name must bedefined and this toggler will be 'disabled'
					if (settingOptionsNames.length > 1 || (settingOptionsNames.length == 1 && setting.options[settingOptionsNames[0]]['toggler_text'])) {
						this.setup.togglersCount++;
						hasToggler = true; // show toggler if there is more than 1 option
						horizontalToggler = setting.horizontal_toggler != undefined && setting.horizontal_toggler === 'true' ? true : false;
					}

					// Default option index ----------------------------
					if (setting.default_option !== undefined) { // default_option is defined in parameter
						defaultIndex = setting.default_option - 1; // default index from settings minus 1 so it match with iteration index

					} else if (setting.platform_detect === 'true') { // default_option not defined but platform detection is active

						// Check if there is option with same platform as detected user's platform
						// NOTE: if options in dataset are not ordered by number, the toggler will not match!!! Reason is that index is not option name.
						defaultIndex = searchPlatform(setting, detectedPlatform); // Lookup for option in given setting for detected platform

						if (defaultIndex === false) { // if there is no option for detected platform, look up for option with default platform
							if (!setting.default_platform) { // if there is no default platform defined, use first option
								defaultIndex = 0;
							} else {
								defaultIndex = searchPlatform(setting, setting.default_platform);

								// TODO - check if setting.default_platform is a string or array. If string, use just one value. If array, search for default platform for detected platform.
							}

							if (defaultIndex === false) { // if no option with default platform is found, use first option
								defaultIndex = 0;
							}
						}
					} else { // if there is no default_option and no platform_detect, use first option
						defaultIndex = 0;
					}

					// add values of this setting to the Setup
					this.addSet(defaultIndex, hasToggler, horizontalToggler, 1, 1);

					// Option values ------------------------------
					for (var o = 0; o < settingOptionsNames.length; o++) {
						var
							optionName = settingOptionsNames[o],
							optionSetting = setting.options[optionName],
							pricelistsCount = optionSetting['pricelist'] !== undefined ? Object.keys(optionSetting['pricelist']).length : 0,
							promotedBox = optionSetting.promoted_box !== undefined ? parseFloat(optionSetting.promoted_box) : false,
							togglerText = optionSetting['toggler_text'] !== undefined ? optionSetting['toggler_text'] : ('option_'+ (o+1)),
							boxesCount = 0; // count of rendered boxes in the option

						// how many boxes should be rendered for this option
						if (pricelistsCount >= 1) {
							boxesCount = pricelistsCount;
						} else if (pricelistsCount == 0) {
							boxesCount = 1;
						}

						// toggler values of this option in this set
						if (optionSetting['toggler_text'] != undefined)
						this.setup.sets[s].togglerValues.push(togglerText);

						// add values of this option to the Setup
						this.addOption(s, boxesCount, optionType(pricelistsCount), promotedBox);
					};
				};
				this.updateSetup(); // calculate toggler positions in grid and boxcounts
			},
			methods: {
				changeIndex: function(event, value, setIndex) {
					this.setup.sets[setIndex].selectedIndex = value; // update setup with selected option index
					this.updateSetup(); // recalculate the rest of setup
					this.$nextTick(function(){window.dispatchEvent(this.eventData)}) // send global event on toggler change
				},

				// add setting to the Setup
				addSet: function(selectedIndex, hasToggler, horizontalToggler) {
					var newSet = {
						"selectedIndex": selectedIndex,
						"hasToggler": hasToggler,
						"horizontalToggler": horizontalToggler,
						"firstBox": 0,
						"lastBox": 0,
						"togglerValues": [],
						"options": []
					}
					this.setup.sets.push(newSet);
				},

				// add option to parent setting in the Setup
				addOption: function(setIndex, boxesCount, optionType, promotedBox) {
					var newOption = {
						"boxesCount": boxesCount,
						"optionType": optionType,
						"promotedBox": promotedBox
					}
					this.setup.sets[setIndex].options.push(newOption);
				},

				// calculate setup params (while init and when togglers change status)
				updateSetup: function() {
					var
						boxesCountSum = 0,   // box count init value
						start = 0,           // toggler start column- init value
						hasPromo = false,    // promo detection init value
						addresses = [];      // array for rendered boxes setup addresses

					for (var s = 0; s < this.setup.settingsCount; s++) {
						var
							set = this.setup.sets[s],
							selectedIndex = set.selectedIndex, // selected option index
							selectedOption = set.options[selectedIndex], //
							optionBoxes = selectedOption.boxesCount; // how many has selected option boxes

						// calculate box count and define addresses of rendered boxes
						if (optionBoxes >= 1) {
							boxesCountSum += optionBoxes;

							for (var p = 0; p < optionBoxes; p++) {
								addresses.push({
									"set": s,
									"option": selectedIndex,
									"price": p
								});
							}
						} else if (optionBoxes == 0) {
							boxesCountSum++;

							addresses.push({
								"set": s,
								"option": selectedIndex,
								"price": 1
							});
						}
						this.setup.renderedBoxesCount = boxesCountSum;

						// toggler position and span
						set.firstBox = start + 1;
						set.lastBox = start + optionBoxes;
						start += optionBoxes;
					}
					this.setup.renderedBoxes = addresses;

					// promoted box index detection (i.e. which of rendered option of a set has the promotion - first found serves)
					addresses.forEach(function(boxAddress, i) {
						var
							set = boxAddress.set,       // this setting index
							option = boxAddress.option, // this option index
							price = boxAddress.price,   // this option pricelist index
							promotedBox = this.sets[set].options[option].promotedBox; // order of promoted box in this option

						// if promo wasn't found yet during the loop
						if (!hasPromo && price+1 == promotedBox) {
							// if there is value in the setting, the assign the value
							hasPromo = promotedBox && promotedBox != null ? promotedBox : false;

							// if promo is not false and it is in the range of count of rendered boxes, then assign the value
							hasPromo = hasPromo && hasPromo > 0 && hasPromo <= boxesCountSum ? i + 1 : false;
						}
					}, this.setup);
					this.setup.promotedBox = hasPromo;
				}
			},
			computed: {
				eventData: function() {
					return new CustomEvent('actionbox-updated', {'detail': {'element':this.$el}});
				}
			}
		});
	};


	// METHODS
	// --------------------------------------------------------------------------------------------------------------

	// Type of option based on number of pricelists
	function optionType(number) {
		if (number > 1) {
			return "multi";
		} else if (number == 1) {
			return "single";
		} else {
			return "trial";
		}
	};

	// Checks if price is monthly
	function isYearPeriod(obj) {
		if (obj.priceFlag == "M" || obj.maintenance == 1) {
			return false;
		} else {
			return true;
		}
	}

	// Lookup the user platform in given dataset.
	// Will look up such option where detected platform matches with value in parameter 'platform'. If there are more with the same name, the last one is selected
	function searchPlatform(dataset, platform) {
		var returnedValue = false;

		Object.keys(dataset.options).forEach(function(optionName, i) {
			if ('platform' in dataset.options[optionName]) {
				if (platform.toUpperCase() === dataset.options[optionName].platform.toUpperCase()) {
					returnedValue = i;
				}
			}
		});
		return returnedValue;
	}

	// Legal notes modal initialization
	function initModal(modalButton) { // button triggering the modal
		var
			//modalButton = element.querySelector('[data-toggle="modal"]'),
			modalTarget = modalButton !== null ? modalButton.getAttribute('data-target') : null;

		// load modal in the moment of user interaction
		if (modalButton !== null && modalTarget !== null) {
			// pass modal name to modal loader
			modalButton.addEventListener('click', function(e) {
				e.stopImmediatePropagation(); // prevent selection of the whole abox
				loadModal(modalTarget);
			});
			modalButton.addEventListener('keypress', function(e) {
				if (e.charCode === 13) {
					loadModal(modalTarget);
				}
			});
		}
	}

	function loadModal(target) {
		/* ATTENTION: make sure name of source page for modal and target in modal trigger are same!!
		- subscription-modal => Global legal text
		- subscription-modal-gb => GB yearly legal text
		- subscription-modal-gb-month => GB monthly legal text
		*/
		// if modal with name in the target is not on page
		if(document.getElementById(target) === null) {
			var
				contentHolder = document.querySelector('.content-holder'),
				xhr = new XMLHttpRequest();

			xhr.onreadystatechange = function() {
				if (this.readyState == 4 && this.status == 200) {
					var container = document.createElement('div');

					container.innerHTML = this.responseText;
					contentHolder.append(container);

					var modal = new BSN.Modal(document.getElementById(target));
					modal.show();
				}
			};
			xhr.open('GET', 'https://' + avastGlobals.web.domain + '/' + avastGlobals.web.ulocale + '/' + target, true);
			xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
			xhr.send(null);

		} else {
			var modal = new BSN.Modal(document.getElementById(target));
			modal.show();
		}
	}
})();
